import RailsResource from './rails-resource';

export default new class UserService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'users',
      ajaxLoader: false
    })
  }

  redefinePassword(userId, password, passwordConfirmation) {
    return this.post(`${this.url}/${this.resource}/${userId}/reset-password`, true, {
      password: password,
      passwordConfirmation: passwordConfirmation
    });
  }
}